/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import PhysicalObjectType from './PhysicalObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="fkColumn" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkCatalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkSchema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkTable" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkColumn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ForeignKey extends PhysicalObjectType{

	fkColumn = null;



	/**
	 * Gets the value of the fkColumn property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the fkColumn property. <p> For example, to add a new item, do as follows: <pre> getFkColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ForeignKey.FkColumn}
	 */
	getFkColumn() {
		if (!this.fkColumn) {
			this.fkColumn = [];
		}
		return this.fkColumn;
	}

	/**
	 * Gets the value of the <code>fkColumn</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>FkColumn</code> elements, or <code>null</code> if not set
	 */
	basicGetFkColumn() {
		return this.fkColumn;
	}

	/**
	 * Creates a new instance of <code>ForeignKey</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ForeignKey</code> object from.
	 * @return {ForeignKey} an object of type <code>ForeignKey</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createForeignKey();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addFkColumnAt(position, item) {
		this._addAtAndNotify(this.getFkColumn(), position, item, 3, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addFkColumn(item) {
		this.addFkColumnAt(this.getFkColumn().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeFkColumnAt(position) {
		this._removeAtAndNotify(this.getFkColumn(), position, 3, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeFkColumn(item) {
		var i = this.getFkColumn().indexOf(item);
		if (i >= 0) {
			this.removeFkColumnAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ForeignKey";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createForeignKeyFkColumn().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 3, "fkColumn", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 3:
			this.fkColumn = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 3:
			return this.getFkColumn();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 3:
			return this.basicGetFkColumn();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 3:
			this.addFkColumnAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 3:
			this.addFkColumn((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 3:
			this.removeFkColumnAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 3:
			this.removeFkColumn((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="columnName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkCatalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkSchema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkTable" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="pkColumn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
ForeignKey.FkColumn = class extends MoserObject{

	columnName = null;

	pkCatalog = null;

	pkSchema = null;

	pkTable = null;

	pkColumn = null;



	/**
	 * Gets the value of the columnName property.
	 * @return {String} possible object is {@link String}
	 */
	getColumnName() {
		return this.columnName;
	}

	/**
	 * Sets the value of the columnName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setColumnName(value) {
		var oldValue = this.columnName;
		this.columnName = value;
		this._setAndNotify(144, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the pkCatalog property.
	 * @return {String} possible object is {@link String}
	 */
	getPkCatalog() {
		return this.pkCatalog;
	}

	/**
	 * Sets the value of the pkCatalog property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPkCatalog(value) {
		var oldValue = this.pkCatalog;
		this.pkCatalog = value;
		this._setAndNotify(147, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the pkSchema property.
	 * @return {String} possible object is {@link String}
	 */
	getPkSchema() {
		return this.pkSchema;
	}

	/**
	 * Sets the value of the pkSchema property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPkSchema(value) {
		var oldValue = this.pkSchema;
		this.pkSchema = value;
		this._setAndNotify(148, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the pkTable property.
	 * @return {String} possible object is {@link String}
	 */
	getPkTable() {
		return this.pkTable;
	}

	/**
	 * Sets the value of the pkTable property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPkTable(value) {
		var oldValue = this.pkTable;
		this.pkTable = value;
		this._setAndNotify(149, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the pkColumn property.
	 * @return {String} possible object is {@link String}
	 */
	getPkColumn() {
		return this.pkColumn;
	}

	/**
	 * Sets the value of the pkColumn property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPkColumn(value) {
		var oldValue = this.pkColumn;
		this.pkColumn = value;
		this._setAndNotify(150, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>FkColumn</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> FkColumn</code> object from.
	 * @return {FkColumn} an object of type <code>FkColumn</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createForeignKeyFkColumn();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "FkColumn";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 144, "columnName", null));
		featureList.push(this.createFeature(false, false, false, 147, "pkCatalog", null));
		featureList.push(this.createFeature(false, false, false, 148, "pkSchema", null));
		featureList.push(this.createFeature(false, false, false, 149, "pkTable", null));
		featureList.push(this.createFeature(false, false, false, 150, "pkColumn", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 144:
			this.setColumnName((value));
			break;
		case 147:
			this.setPkCatalog((value));
			break;
		case 148:
			this.setPkSchema((value));
			break;
		case 149:
			this.setPkTable((value));
			break;
		case 150:
			this.setPkColumn((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 144:
			return this.getColumnName();
		case 147:
			return this.getPkCatalog();
		case 148:
			return this.getPkSchema();
		case 149:
			return this.getPkTable();
		case 150:
			return this.getPkColumn();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 144:
			return this.getColumnName();
		case 147:
			return this.getPkCatalog();
		case 148:
			return this.getPkSchema();
		case 149:
			return this.getPkTable();
		case 150:
			return this.getPkColumn();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ForeignKey.js